import { useState, useEffect } from 'react';

/**
 * 모바일 화면 감지 훅
 * - 1400px 이하를 모바일로 판단 (패드 포함)
 * - 1401px 이상을 PC 환경으로 판단
 * @param {number} breakpoint - 모바일 기준 너비 (기본값: 1400px)
 * @returns {boolean} 모바일 여부
 */
function useIsMobile(breakpoint = 1400) {
  const [isMobile, setIsMobile] = useState(function () {
    if (typeof window === 'undefined') return false;
    return window.innerWidth <= breakpoint;
  });

  useEffect(
    function () {
      function handleResize() {
        setIsMobile(window.innerWidth <= breakpoint);
      }

      // 초기값 설정
      handleResize();

      // 리사이즈 이벤트 리스너 등록
      window.addEventListener('resize', handleResize);

      return function () {
        window.removeEventListener('resize', handleResize);
      };
    },
    [breakpoint],
  );

  return isMobile;
}

export default useIsMobile;
